import { Card } from '@/components/Card';
import { Loading } from '@/components/Loading';
import { Text } from '@/components/Text';
import { useTranslation } from 'react-i18next';

export const PageBuildLoader = () => {
  const { t } = useTranslation('pageBuildLoader');

  return (
    <div className="flex min-h-[80vh] items-center justify-center p-4">
      <Card className="w-full max-w-2xl p-8 text-center">
        <div className="flex flex-col items-center gap-6">
          <Loading message={t('title')} description={t('subtitle')} />
          <Text className="max-w-lg text-lg">{t('description')}</Text>
          <Text className="text-sm text-gray-500">{t('notification')}</Text>
        </div>
      </Card>
    </div>
  );
};
